var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2067 8.41056H24.8054C24.1943 8.41056 23.6787 7.89304 23.6787 7.28383C23.6769 6.67274 24.1944 6.15527 24.8054 6.15527H37.2067C37.8178 6.15527 38.3335 6.67279 38.3335 7.282C38.3353 7.89309 37.8178 8.41056 37.2067 8.41056Z",
    fill: "url(#paint0_linear_2824_38742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2067 13.5304H24.8054C24.1943 13.5304 23.6787 13.0128 23.6787 12.4036C23.6769 11.7925 24.1944 11.3228 24.8054 11.3228H37.2067C37.8178 11.3228 38.3335 11.8403 38.3335 12.4495C38.3353 13.0606 37.8178 13.5304 37.2067 13.5304Z",
    fill: "url(#paint1_linear_2824_38742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2067 18.6978H24.8054C24.1943 18.6978 23.6787 18.1803 23.6787 17.5711C23.6787 16.96 24.1962 16.4443 24.8054 16.4443H37.2067C37.8178 16.4443 38.3335 16.9618 38.3335 17.5711C38.2876 18.228 37.8178 18.6978 37.2067 18.6978Z",
    fill: "url(#paint2_linear_2824_38742)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3343 22.784C38.3343 23.3951 37.8168 23.9107 37.2076 23.9107L30.6918 23.9125C30.5271 23.9125 30.3644 23.8765 30.2151 23.8069C29.1213 23.2971 29.4847 21.6572 30.6915 21.6572H37.2057C37.8168 21.6572 38.3343 22.1748 38.3343 22.784Z",
    fill: "url(#paint3_linear_2824_38742)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7964 19.861C20.8601 20.4278 20.5518 20.9711 20.0326 21.2072L13.9293 23.9818C13.7581 24.0596 13.5723 24.0998 13.3842 24.0998H7.3275C6.71641 24.0998 6.24663 23.5823 6.29436 22.9731L6.62284 19.5433C6.85644 17.5339 8.2045 15.9439 10.0226 15.2785C10.0424 15.2712 10.0634 15.2676 10.0845 15.2676C10.1245 15.2676 10.1634 15.2808 10.1955 15.3047C11.174 16.0339 12.3764 16.442 13.7173 16.442C15.0674 16.442 16.2804 16.0271 17.2633 15.2866C17.2796 15.2743 17.2995 15.2676 17.3199 15.2676C17.3306 15.2676 17.3413 15.2694 17.3514 15.2731C19.1751 15.9337 20.5317 17.5744 20.7659 19.5892L20.7964 19.861Z",
    fill: "url(#paint4_linear_2824_38742)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.716 14.7982C16.1585 14.7982 18.1312 12.8255 18.1312 10.383C18.1312 7.94048 16.1585 5.96777 13.716 5.96777C11.2735 5.96777 9.30078 7.94048 9.30078 10.383C9.30078 12.8255 11.2735 14.7982 13.716 14.7982Z",
    fill: "url(#paint5_linear_2824_38742)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5695 0H6.05925C2.72488 0 0 2.72511 0 6.06112V24.0063C0 27.3425 2.72511 30.0656 6.05925 30.0656H8.82726C9.08834 30.0656 9.25228 29.8569 9.25228 29.5958V29.1751C9.25228 28.4477 8.66257 27.858 7.93512 27.858H6.01153C3.89752 27.858 2.1597 26.1201 2.1597 24.0061L2.16153 6.06094C2.16153 3.94692 3.89935 2.2091 6.01337 2.2091H38.5218C40.6358 2.2091 42.3736 3.94692 42.3736 6.06094V24.0061C42.3736 26.1201 40.6358 27.858 38.5218 27.858H36.5982C35.8708 27.858 35.2811 28.4477 35.2811 29.1751V29.5958C35.2811 29.8288 35.4748 30.0656 35.7078 30.0656H38.4741C41.8103 30.0656 44.5333 27.3405 44.5333 24.0063L44.5352 6.06112C44.6288 2.72492 41.9038 0 38.5695 0Z",
    fill: "url(#paint6_linear_2824_38742)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 32.7468C13.9062 32.0194 14.496 31.4297 15.2234 31.4297H15.4555C16.183 31.4297 16.7727 32.0194 16.7727 32.7468V38.8035C16.7727 39.5309 16.183 40.1206 15.4555 40.1206H15.2234C14.496 40.1206 13.9062 39.5309 13.9062 38.8035V32.7468Z",
    fill: "url(#paint7_linear_2824_38742)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5557 32.7468C18.5557 32.0194 19.1454 31.4297 19.8728 31.4297H20.1049C20.8324 31.4297 21.4221 32.0194 21.4221 32.7468V38.8035C21.4221 39.5309 20.8324 40.1206 20.1049 40.1206H19.8728C19.1454 40.1206 18.5557 39.5309 18.5557 38.8035V32.7468Z",
    fill: "url(#paint8_linear_2824_38742)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2061 32.7468C23.2061 32.0194 23.7958 31.4297 24.5232 31.4297H24.7553C25.4828 31.4297 26.0725 32.0194 26.0725 32.7468V38.8035C26.0725 39.5309 25.4828 40.1206 24.7553 40.1206H24.5232C23.7958 40.1206 23.2061 39.5309 23.2061 38.8035V32.7468Z",
    fill: "url(#paint9_linear_2824_38742)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9043 32.7468C27.9043 32.0194 28.494 31.4297 29.2215 31.4297H29.4536C30.181 31.4297 30.7707 32.0194 30.7707 32.7468V38.8035C30.7707 39.5309 30.181 40.1206 29.4536 40.1206H29.2215C28.494 40.1206 27.9043 39.5309 27.9043 38.8035V32.7468Z",
    fill: "url(#paint10_linear_2824_38742)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6024 41.5303H12.0274C11.7925 41.5303 11.5576 41.7175 11.5576 42.0001V43.8315C11.5576 44.0663 11.7448 44.3012 12.0274 44.3012H32.5564C32.7913 44.3012 33.0262 44.1141 33.0262 43.8315V42.0001C33.0262 41.7175 32.8373 41.5303 32.6024 41.5303Z",
    fill: "url(#paint11_linear_2824_38742)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.791 27.4821L22.5037 22.7843C22.4101 22.7366 22.2688 22.7366 22.1275 22.7843L11.9342 27.4392C11.8717 27.4678 11.8101 27.4996 11.7571 27.5435C11.6484 27.6337 11.5576 27.7542 11.5576 27.9042V29.5962C11.5576 29.8311 11.7448 30.066 12.0274 30.066H32.5564C32.7913 30.066 33.0262 29.8788 33.0262 29.5962V27.9042C33.0262 27.717 32.9323 27.5298 32.791 27.4821ZM22.3144 28.3281C21.4684 28.3281 20.7637 27.6234 20.7637 26.7775C20.7637 25.9315 21.4684 25.2268 22.3144 25.2268C23.1604 25.2268 23.865 25.9315 23.865 26.7775C23.865 27.6711 23.1604 28.3281 22.3144 28.3281Z",
    fill: "url(#paint12_linear_2824_38742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2824_38742",
    x1: 24.2893,
    y1: 6.60633,
    x2: 33.2632,
    y2: 14.7052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2824_38742",
    x1: 24.2893,
    y1: 11.7643,
    x2: 33.0907,
    y2: 19.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2824_38742",
    x1: 24.2893,
    y1: 16.895,
    x2: 33.2566,
    y2: 24.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2824_38742",
    x1: 26.133,
    y1: 22.1083,
    x2: 34.8938,
    y2: 28.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2824_38742",
    x1: 6.89986,
    y1: 17.034,
    x2: 22.3214,
    y2: 20.5776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2824_38742",
    x1: 9.66871,
    y1: 7.73385,
    x2: 19.2946,
    y2: 9.07078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2824_38742",
    x1: 1.85573,
    y1: 6.01312,
    x2: 49.3322,
    y2: 15.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2824_38742",
    x1: 14.0257,
    y1: 33.1679,
    x2: 17.2039,
    y2: 33.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2824_38742",
    x1: 18.6751,
    y1: 33.1679,
    x2: 21.8533,
    y2: 33.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2824_38742",
    x1: 23.3255,
    y1: 33.1679,
    x2: 26.5037,
    y2: 33.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2824_38742",
    x1: 28.0237,
    y1: 33.1679,
    x2: 31.202,
    y2: 33.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2824_38742",
    x1: 12.4521,
    y1: 42.0845,
    x2: 23.5063,
    y2: 53.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2824_38742",
    x1: 12.4521,
    y1: 24.212,
    x2: 32.9093,
    y2: 32.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5676D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetails);
export default __webpack_public_path__ + "static/media/account-details.480c09000e19a94af5bd557fb36b6c06.svg";
export { ForwardRef as ReactComponent };